import { FC, useRef, useState } from 'react';
import { Modal, ModalProps, Spinner } from 'react-bootstrap';
import StyledModal from './styled';
import LeadCityLawyerForm from '../CityLawyer/LeadCityLawyerForm';
import { CardStyled } from "../../components/Card.styled";
import { Container, Row, Col } from "react-bootstrap";
import Text from "../../styled/Text";

const CityLawyerPopUp: FC<ModalProps> = props => {
  return (
    <StyledModal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div className='row' style={{textAlign : 'end', marginRight : '-8px'}} >
            <div className='col-12'>
              <img src="/city-lawyers/icons/close.svg"  onClick={props.onHide} width="15" alt="close"/>
            </div>
          </div>
        {/* <Col> */}
          <CardStyled className="">
            <CardStyled.Header className="d-flex align-items-center justify-content-center">
              <Text className="mb-0 underline" fontSize="lg" weight="semibold">
                Ask Lawyer
              </Text>
            </CardStyled.Header>
            <CardStyled.Body>
              <LeadCityLawyerForm />
            </CardStyled.Body>
          </CardStyled>
        {/* </Col> */}
        {/* <LeadCityLawyerForm /> */}
      </Modal.Body>
    </StyledModal>
  );
};

export default CityLawyerPopUp;
